import { jsx as f } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import p from "../builders-icons/dist/systems/chevron-down.js";
import s from "clsx";
import o from "./chevron.module.css.js";
const x = n(function({ className: r, open: m, ...t }, e) {
  return /* @__PURE__ */ f(
    p,
    {
      className: s(o.chevron, r, { [o.open]: m }),
      ref: e,
      ...t
    }
  );
});
export {
  x as Chevron
};
//# sourceMappingURL=chevron.js.map
